import React from 'react'
import './Tittle.css';

const Tittle = ({title}) => {
  return (
    <>
    <div className='sec-name'>
     <h3>{title}</h3>
     <hr />
    </div>

    </>
  )
}

export default Tittle;